import React, { Component } from 'react';
import { Row, Col, ButtonGroup, Button, Input } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import { StyledCard } from '../../Base/Common/CommonUIComponents';
import { CustomTable } from '../../Base/Common/CustomTable';
import { getAPI } from '../../Base/API';
import { CustomDateRangePicker } from '../../Base/Common/CustomReactDates';

export class SignInLogs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            block: true,
            authenticationAttempts: [],
            startDate: moment().subtract(1, 'days'),
            endDate: moment(),
            email: null,
            skipTokens: [],
            pageIndex: 0,
            pageSize: 10,
            totalItems: 0
        };
    }

    componentDidMount() {
        this.getAuthenticationAttempts();
    }

    getAuthenticationAttempts = () => {
        const { startDate, endDate, email, skipTokens, pageSize } = this.state;

        const skipToken = skipTokens.length > 0 ? skipTokens[skipTokens.length - 1] : null;

        getAPI(result => {
            const { data, error } = result;

            const errorMessage = [];
            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false, authenticationAttempts: [] });
                return;
            }
            if (data) {
                if (data.response) {
                    skipTokens.push(data.skipToken);
                    this.setState({ block: false, error: errorMessage, authenticationAttempts: data.response, totalItems: data.response.length, skipTokens });
                }
                else {
                    this.setState({ block: false, error: errorMessage, authenticationAttempts: [] });
                }
            }
            else {
                this.setState({ block: false, error: errorMessage, authenticationAttempts: [] });
            }
        }, `/api/User/v1/User/getAuthenticationAttempts?pageSize=${pageSize}&loginDateFrom=${moment(startDate).format("YYYY-MM-DD")}&loginDateTo=${moment(endDate).format("YYYY-MM-DD") }${email ? `&email=${email}` : `` }${skipToken ? `&skipToken=${skipToken}` : `` }`);
    }

    changePageSize = (evt) => {
        const { pageSize, skipTokens } = this.state;
        if (evt) {
            evt.preventDefault();
        }

        const { value } = evt.target;

        if (pageSize !== value) {
            skipTokens.splice(skipTokens.length - 1, 1);
            this.setState({ block: true, pageSize: value }, this.getAuthenticationAttempts);
        }
    }

    handlePrevious = () => {
        const { pageIndex, skipTokens } = this.state;

        skipTokens.splice(skipTokens.length - 2, 2);
        this.setState({ pageIndex: parseInt(pageIndex - 1), skipTokens, block: true }, this.getAuthenticationAttempts);
    }

    handleChange = (evt) => {
        if (evt && evt.target) {
            const { name, value } = evt.target;
            this.setState({ [name]: value });
        }
    }

    doSearch = () => {
        this.setState({ skipTokens: [], block: true }, this.getAuthenticationAttempts);
    }

    render() {
        const { error, block, authenticationAttempts, startDate, endDate, pageIndex, pageSize, email } = this.state;

        const columns = [
            {
                dataField: 'createdDateTime',
                text: <FormattedMessage id="SignInLogs.CreatedDateTime" />,
                sort: true
            },
            {
                dataField: 'userId',
                text: <FormattedMessage id="SignInLogs.UserId" />,
                sort: true
            },
            {
                dataField: 'userDisplayName',
                text: <FormattedMessage id="SignInLogs.UserDisplayName" />,
                sort: true
            },
            {
                dataField: 'userPrincipalName',
                text: <FormattedMessage id="SignInLogs.UserPrincipalName" />,
                sort: true
            },
            {
                dataField: 'appDisplayName',
                text: <FormattedMessage id="SignInLogs.AppDisplayName" />,
                sort: true
            },
            {
                dataField: 'ipAddress',
                text: <FormattedMessage id="SignInLogs.IpAddress" />,
                sort: true
            },
            {
                dataField: 'statusErrorCode',
                text: <FormattedMessage id="SignInLogs.StatusErrorCode" />,
                sort: true,
                formatter: (_, row) => <div>{row.status.errorCode}</div>
            },
            {
                dataField: 'StatusFailureReason',
                text: <FormattedMessage id="SignInLogs.StatusFailureReason" />,
                sort: true,
                formatter: (_, row) => <div>{row.status.failureReason}</div>
            },
            {
                dataField: 'statusAdditionalDetails',
                text: <FormattedMessage id="SignInLogs.StatusAdditionalDetails" />,
                sort: true,
                formatter: (_, row) => <div>{row.status.additionalDetails}</div>
            },
            {
                dataField: 'deviceDetailOperatingSystem',
                text: <FormattedMessage id="SignInLogs.DeviceDetailOperatingSystem" />,
                sort: true,
                formatter: (_, row) => <div>{row.deviceDetail.operatingSystem}</div>
            },
            {
                dataField: 'deviceDetailBrowser',
                text: <FormattedMessage id="SignInLogs.DeviceDetailBrowser" />,
                sort: true,
                formatter: (_, row) => <div>{row.deviceDetail.browser}</div>
            },
            {
                dataField: 'locationCity',
                text: <FormattedMessage id="SignInLogs.LocationCity" />,
                sort: true,
                formatter: (_, row) => <div>{row.location.city}</div>
            },
            {
                dataField: 'locationState',
                text: <FormattedMessage id="SignInLogs.LocationState" />,
                sort: true,
                formatter: (_, row) => <div>{row.location.state}</div>
            },
            {
                dataField: 'locationCountryOrRegion',
                text: <FormattedMessage id="SignInLogs.LocationCountryOrRegion" />,
                sort: true,
                formatter: (_, row) => <div>{row.location.countryOrRegion}</div>
            }
        ];

        return (
            <StyledCard icon={'fas fa-user'} title={'navbar.SignInLogs'} error={error} block={block}>
                <Row className="mt-4 mb-2">
                    <Col className="col-3">
                        <CustomDateRangePicker
                            startDate={startDate}
                            startDateId="signInLogsStartDate_id"
                            isOutsideRange={day => day <= moment().subtract(7, 'days') || day.isAfter(moment())}
                            showYearOptions={{ pastYears: false, futureYears: false }}
                            endDate={endDate}
                            endDateId="signInLogsEndDate_id"
                            onDatesChange={(startDate, endDate) => this.setState({ startDate, endDate })}
                            numberOfMonths={1}
                            pastYears={1}
                            futureYears={0}
                        />
                    </Col>
                    <Col className="col-3">
                        <FormattedMessage id="SignInLogs.Email">
                            {
                                placeholder => <Input type="text" id="email" name="email" onChange={this.handleChange} value={email} placeholder={placeholder} />
                            }
                        </FormattedMessage>
                    </Col>
                    <Col className="text-right">
                        <Button className="primary btn-host btn-sm" onClick={this.doSearch}>
                            <i className="fas fa-search" />
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CustomTable
                            data={authenticationAttempts}
                            columns={columns}
                            shadow={false}
                            exportCSV={false}
                            showTotal={false}
                            search={false}
                            hideSizePerPage={true}
                            sizePerPage={pageSize}
                            hasPagination={false}
                        />
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col>
                        <ButtonGroup onClick={this.changePageSize}>
                            <Button className={(pageSize == 10 ? "btn btn-host btn-sm text-white" : "btn btn-sm text-secondary") + " page-link"} value={10}> 10 </Button>
                            <Button className={(pageSize == 25 ? "btn btn-host btn-sm text-white" : "btn btn-sm text-secondary") + " page-link"} value={25}> 25 </Button>
                            <Button className={(pageSize == 30 ? "btn btn-host btn-sm text-white" : "btn btn-sm text-secondary") + " page-link"} value={30}> 30 </Button>
                            <Button className={(pageSize == 50 ? "btn btn-host btn-sm text-white" : "btn btn-sm text-secondary") + " page-link"} value={50}> 50 </Button>
                        </ButtonGroup>
                    </Col>
                    <Col className="text-right">
                        <span>
                            <Button className="btn btn-host btn-sm mr-2" onClick={this.handlePrevious} disabled={pageIndex === 0}>
                                <i className="fas fa-angle-left" />
                            </Button>
                            <span className="mr-2">
                                <FormattedMessage id="Pagination.Page" values={{ page: parseInt(pageIndex + 1) }} />
                            </span>
                            <Button className="btn btn-host btn-sm" onClick={_ => this.setState({ pageIndex: parseInt(pageIndex + 1), block: true }, this.getAuthenticationAttempts)} disabled={authenticationAttempts && authenticationAttempts.length < pageSize}>
                                <i className="fas fa-angle-right" />
                            </Button>
                        </span>
                    </Col>
                </Row>
            </StyledCard>
        );
    }
}